module.exports = __webpack_public_path__ + "img/vita_stu_photo.2fe92703.png";